export default {
    // 登录程序查询接口
    listLoginProcessByCondition(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/loginProcess/listLoginProcessByCondition', params, response);
    },
    // 消息中间件资源类型查询接口
    updateLoginProcessByCondition(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/loginProcess/updateLoginProcessByCondition', params, response);
    },
    listLoginProcess(params, response) {
        return window.vue.$apiAxios.get('/auth/loginProcess/listLoginProcess', params, response);
    }
};
